import React from 'react'
import styles from './styles.css'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import PropTypes from 'prop-types'
import Button from 'orionsoft-parts/lib/components/Button'
import autobind from 'autobind-decorator'
import cloneDeep from 'lodash/cloneDeep'
import DeleteIcon from 'react-icons/lib/md/close'
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from 'react-sortable-hoc'

const SortableItem = SortableElement(({ item }) => <div>{item}</div>)

const SortableList = SortableContainer(({ items, draggable }) => {
  return (
    <div>
      {items.map((item, index) => (
        <SortableItem
          disabled={!draggable}
          key={`item-${index}`}
          index={index}
          item={item}
        />
      ))}
    </div>
  )
})

export default class RequiredFiles extends React.Component {
  static propTypes = {
    value: PropTypes.array,
    size: PropTypes.number,
    onChange: PropTypes.func,
    draggable: PropTypes.bool,
    addMe: PropTypes.bool,
    me: PropTypes.func,
    autoAdd: PropTypes.bool
  }

  static defaultProps = {
    autoAdd: false,
    size: 0
  }

  componentDidMount() {
    if (!this.props.autoAdd) return
    const items = cloneDeep(this.props.value || [])
    items.push({})
    this.props.onChange(items)
  }

  @autobind
  add() {
    const items = cloneDeep(this.props.value || [])
    items.push({})
    this.props.onChange(items)
  }

  onChange(value, field, index) {
    const items = cloneDeep(this.props.value || [])
    items[index][field] = value
    this.props.onChange(items)
  }

  delete(index) {
    const items = cloneDeep(this.props.value || [])
    items.splice(index, 1)
    this.props.onChange(items)
  }

  renderRequiredFiles() {
      const value = this.props.value || []
      const roles = value.map((signer, index) => {
        const onChange = field => value => this.onChange(value, field, index)
        return (
          <div key={index} className="row">
            {this.props.draggable && (
              <div className="col-xs-12 col-sm-1">{index + 1}</div>
            )}
            <div className="col-xs-12 col-sm-10">
              <Text
                value={signer.name}
                onChange={onChange('name')}
                placeholder="Adjunto requerido"
              />
            </div>
            <div className="col-xs-2 col-sm-1">
              <div className={styles.delete} onClick={() => this.delete(index)}>
                <DeleteIcon size={20} />
              </div>
            </div>
          </div>
        )
      })
    const onSortEnd = ({ oldIndex, newIndex }) =>
      this.props.onChange(arrayMove(value, oldIndex, newIndex))
    return (
      <SortableList
        distance={2}
        items={roles}
        size={roles.length}
        draggable={this.props.draggable}
        onSortEnd={onSortEnd}
      />
    )
  }

  render() {
    return (
      <div className={styles.container}>        
        {this.renderRequiredFiles()}
        <Button onClick={this.add}>Agregar Adjunto</Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/fields/RequiredFiles/index.js